import { router } from 'expo-router';
import * as React from 'react';
import {
    ArrowUpRightIcon,
    Icon,
    MailIcon,
    MessageCircleQuestionMarkIcon,
    NavigationRow,
    Row,
    RowList,
    ScreenContainer,
    YStack,
} from 'smoothie';

import { useSendEmailToSupport } from '../../common/hooks/useSendEmailToSupport';
import { SUPPORT_EMAIL } from '../types/constants';
import { TempExperimentPoc } from './TempExperimentPoc';

const SupportSettingsScreen = () => {
    return (
        <ScreenContainer title="Support" hasBackButton={true}>
            <YStack gap={24} justifyContent="space-between">
                <ContactSupportSection />
                <FAQSection />
                <TempExperimentPoc />
            </YStack>
        </ScreenContainer>
    );
};

export default SupportSettingsScreen;

const ContactSupportSection = () => {
    const sendEmailToSupport = useSendEmailToSupport();

    return (
        <RowList>
            <Row
                title="Contact Fruitful Hospitality"
                subtitle={SUPPORT_EMAIL}
                leftIcon={MailIcon}
                onPress={() => {
                    void sendEmailToSupport();
                }}
                rightContent={<Icon icon={ArrowUpRightIcon} />}
            />
        </RowList>
    );
};

const FAQSection = () => {
    return (
        <RowList>
            <NavigationRow
                title="FAQs"
                subtitle="Frequently asked questions"
                leftIcon={MessageCircleQuestionMarkIcon}
                onPress={() => {
                    router.navigate('/settings/faq');
                }}
            />
        </RowList>
    );
};
